/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './dashboards-base.dto';
export * from './average-build-time.dto';
export * from './average-contract-price.dto';
export * from './average-house-cost-change.dto';
export * from './average-preconstruction-build-times.dto';
export * from './average-time-from-sf-to-deposit.dto';
export * from './conversion-rates.dto';
export * from './gross-and-net-profit.dto';
export * from './gross-profit-and-overheads.dto';
export * from './maintenance-tasks-overdue.dto';
export * from './monthly-sales-slabs.dto';
export * from './preconstruction-build-times.dto';
export * from './priority-and-stage.dto';
export * from './sales-leads-budgets.dto';
export * from './salesperson-total.dto';
export * from './top-customers-by-earliest-contact.dto';
export * from './top-customers-by-priority.dto';
export * from './widgets.dto';
